import { Injectable } from '@angular/core';
import { DataService } from './../data/data.service';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver';
export enum Aligment{
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center'
}

export enum TypeRow{
  NORMAL = 'FFFFFFFF',
  TOTAL = 'FFEDEDED',
}

export enum FormatText{
  TEXT = '',
  NUMBERDEC = '#,##0.0#',
  NUMBER = '#,##0',
  DATE = 'dd/mmm/yyyy',
  PORCENTAJE = '0.0%',
  PORCENTAJE2 = '0.0#%'
}
interface GrupoEncabezado {
  titulo: string;
  colspan: number;
  color: string;
}
@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor(
    private dataService: DataService,
  ) {}

  /* Metodos generales */
  // Creación de la hoja de trabajo de excel
  private createExcel(): ExcelJS.Workbook{
    let libroExcel = new ExcelJS.Workbook();
    let hojaTrabajo = libroExcel.addWorksheet('Tabla',{});
    let primerLinea = hojaTrabajo.addRow([]);

    primerLinea.font = {
      name: 'Arial Narrow',
      family: 4,
      size: 16,
      bold: true,
    }
    hojaTrabajo.addRow([]);

    let fec = hojaTrabajo.addRow([]);
    fec.font = { name: 'Arial Narrow', family: 4, size: 12 };

    let realizado = hojaTrabajo.addRow([]);
    realizado.font = { name: 'Arial Narrow', family: 4, size: 12 };
    hojaTrabajo.addRow([]);
    
    return libroExcel;
  }
  // Generación del excel
  private printExcel(nombre: string, libroExcel: ExcelJS.Workbook){
    libroExcel.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(blob, nombre.concat('.xlsx'));
    });
  }
  //Agregga los encabezados al libro de excel así como la imagen
  private addTituloFechaPlataforma(hojaTrabajo: ExcelJS.Worksheet, titulo: string, img){
    hojaTrabajo.getRow(1).values = [titulo]; 
    const fecha = new Date();
    var fech = fecha.toLocaleString();
    hojaTrabajo.getRow(4).values = ['Fecha: '.concat(fech) +' | '+ this.capitalizacionTexto(this.dataService.name)
       + ' ' +this.capitalizacionTexto(this.dataService.lastName)];
    hojaTrabajo.getRow(5).values = [''];
    hojaTrabajo.mergeCells('A1:E2');
    hojaTrabajo.mergeCells('A4:E4');
    
    if(hojaTrabajo.lastColumn.number > 6){
      hojaTrabajo.addImage(img, {
        tl: { col: hojaTrabajo.lastColumn.number-2, row: 1 },
        ext: { width: 100, height: 40 }
      });
    }else{
      hojaTrabajo.addImage(img, {
        tl: { col: 5, row: 1 },
        ext: { width: 100, height: 40 }
      });
    }
  }
  // Genera automaticamente los anchos de las celdas en excel
  private asignarTamanoDinamicoColumnas(hojaTrabajo: ExcelJS.Worksheet, maxWith: number = 100): void{
    let dataMax: number[];
    let max: number;
    hojaTrabajo.columns.forEach((column: any, index) => {
      dataMax = [];
      column.eachCell({ includeEmpty: false }, (cell: any) => {
        if(cell['_mergeCount'] === 0){
          dataMax.push(cell.value?.toString().length || 0);
        }
      });
      max = Math.max(...dataMax);
      if(maxWith !== undefined && max > maxWith){
        max = maxWith;
      }
      column.width = max < 10 ? 10 : max+10;
    });
    if(hojaTrabajo.lastColumn.number > 7){
      hojaTrabajo.pageSetup.printArea = 'A:'+String.fromCodePoint(hojaTrabajo.lastColumn.number+64);
    }else{
      hojaTrabajo.pageSetup.printArea = 'A:'+String.fromCodePoint(7+64);
    }
    hojaTrabajo.pageSetup.scale = 70;
  }
   //Capitaliza el texto
   private capitalizacionTexto(texto){
    var palabra = texto;
    if(texto === "") return "";
    var mayuscula = palabra.substring(0,1).toUpperCase();
    if (palabra.length > 0) {
      var minuscula = palabra.substring(1).toLowerCase();
    }else{
      return mayuscula;
    }
    return mayuscula.concat(minuscula);
  }
  /* Metodos de creacion del excel */
  /**
   * Metodo de creacion de excel general y basico
   * @param titulo titulo para la hoja de excel
   * @param encabezado arreglo string con nombres de las columnas 
   * @param datos arreglo de datos
   * @param nombreArchivo nombre del archivo 
   * @param alineacion arreglo string con alineacion de cada columna (Aligment catalogo)
   * @param formatos arreglo string con formato de cada columna (FormatText catalogo)
   */
  public async generateExcel(
    titulo: string,
    encabezado: string[],
    datos: any,
    nombreArchivo: string,
    alineacion: string[],
    formatos: string[],
    tipo?: string[],
  ){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    datos.forEach((d, i) =>{
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.numFmt = formatos[number-1];

        cell.alignment = {
          vertical: 'middle',
          horizontal: alineacion[number-1] as 'left' | 'center' | 'right',
        };
        var isBold = false;
        var bgColor = '';
        if(!tipo){
          bgColor = 'FFFFFFFF';
        }else{
          bgColor = tipo[i][number-1];
        }
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: bgColor },
        };

        if (cell.value !== '') {
          cell.border = {
            top: {
              style: 'thin',
              color: { argb: 'FFC9C9C9' }
            },
            bottom: {
              style: 'thin',
              color: { argb: 'FFC9C9C9' }
            },
            left: {
              style: 'thin',
              color: { argb: 'FFC9C9C9' }
            },
            right: {
              style: 'thin',
              color: { argb: 'FFC9C9C9' }
            }
          };
        }else {
          cell.border = {
            top: {
              style: 'thin',
              color: { argb: 'FFC9C9C9' }
            },
            bottom: {
              style: 'thin',
              color: { argb: 'FFC9C9C9' }
            }
          };
        }
      });
    });
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  /**
   * 
   * @param titulo titulo del archivo 
   * @param gruposEncabezado primer linea de encabezado con titulo, colspan y color
   * @param encabezado "arreglo de encabezados de columnas segunda linea"
   * @param datos datos
   * @param nombreArchivo nombre del archivo a guardar
   * @param alineacion arreglo de alineacion de columnas 
   * @param formatos arreglo de formatos de columnas
   */
  public async generateExcelDosEncabezados(
    titulo: string,
    gruposEncabezado: GrupoEncabezado[],
    encabezado: string[],
    datos: any,
    nombreArchivo: string,
    alineacion: string[],
    formatos: string[],
  ){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Primera línea
    const titulos: string[] = [];
    for (const grupo of gruposEncabezado) {
      titulos.push(grupo.titulo);
      for (let i = 1; i < grupo.colspan; i++) {
        titulos.push('');
      }
    }
    let headers = hojaTrabajo.addRow(titulos);
    // Formato y combinaciones
  let columnaActual = 1;

  for (const grupo of gruposEncabezado) {
    const columnaInicio = columnaActual;
    const columnaFin =
      columnaActual + grupo.colspan - 1;

    const cell = headers.getCell(columnaInicio);

    cell.font = {
      name: 'Arial Narrow',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: '00616161' },
    };

    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: grupo.color },
      bgColor: { argb: '00000000' },
    };

    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
    };

    if (grupo.colspan > 1) {
      hojaTrabajo.mergeCells(
        headers.number,
        columnaInicio,
        headers.number,
        columnaFin
      );
    }

    columnaActual = columnaFin + 1;
  }

  // Segunda línea
  const headers2 = hojaTrabajo.addRow(encabezado);

  headers2.eachCell((cell, number) => {
    cell.font = {
      name: 'Arial Narrow',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: '00616161' },
    };

    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '00E0E0E0' },
      bgColor: { argb: '00000000' },
    };

    cell.alignment = {
      vertical: 'middle',
      horizontal: number === 1 ? 'left' : 'center',
    };
  });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.numFmt = formatos[number-1];
        cell.alignment = {
          vertical: 'middle',
          horizontal: alineacion[number-1] as 'left' | 'center' | 'right',
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async generateExcelSinTitulo(
    encabezado: string[],
    datos: any,
    nombreArchivo: string,
    alineacion: string[],
    formatos: string[],
    colors?: any,
    filasResaltadas?: boolean[],
  ){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = new ExcelJS.Workbook();
    let hojaTrabajo = libroExcel.addWorksheet('Tabla',{});
    // let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    datos.forEach((d, i) =>{
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.numFmt = formatos[number-1];
        if(colors && colors[i][number-1] !== ''){
          cell.border = {
            right: {
              style: 'thick',
              color: {
                argb: '00'+colors[i][number-1].split('#')[1],
              },
            },
          };
        }
        cell.alignment = {
          vertical: 'middle',
          horizontal: alineacion[number-1] as 'left' | 'center' | 'right',
        };
        var isBold = filasResaltadas?.[i] ?? false;
        var color = isBold ? '00E0E0E0' : '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    })
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }

  public async generateTableResultados(titulo: string, encabezado: string[], datos: any, nombreArchivo: string, colors: string[]){
  // Se genera el libro de excel sobre el que se trabajara
  let libroExcel = this.createExcel();
  let hojaTrabajo = libroExcel.getWorksheet('Tabla');
  // Se hace la asignación de encabezados de la tabla
  let headers = hojaTrabajo.addRow(encabezado);
  //formato de los headers
  headers.eachCell((cell, number) => {
    cell.font = {
      name: 'Arial Narrow',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: 'FFFFFFFF' },
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '00C4C4C4' },
      bgColor: { argb: '00000000' },
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center',
    };
  });
  //Se genera el formato de los datos
  var pos = 0;
  for (const d of datos) {
    let row = hojaTrabajo.addRow(d);
    row.font = { name: 'Arial Narrow', family: 4, size: 11 };
    row.eachCell((cell, number) => {
      //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
      //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
      // Fomato de la celda alineación y otros.
      if(number === 1){
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left',
        };
      }else if(number == 2){
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center',
        };
      }else{
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      }
      var isBold = false;
      var color = '00FFFFFF';
      // Formato y estilo del texto
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: isBold,
        color: { argb: 'FF000000' },
      };
      if(number === 3){
        cell.border = {
          left: {
            style: 'thick',
            color: {
              argb: '00'+colors[pos].split('#')[1],
            },
          },
        };
      }
      // Relleno de las celdas
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: 'FF000000' },
      };
      if(d[0].split('-').length === 1){
        isBold = true;
        color = 'EEEEEEEE';
      }else{
        if(number === 1){
          cell.value = '    '+d[0].split('-')[1];
        }
      }
    });
    pos++;
  }
  // Introducción de la imagen
  const imageSrc = './../../../assets/img/creado.png';
  const response = await fetch(imageSrc);
  const buffer = await response.arrayBuffer();
  let imageId1 = libroExcel.addImage({
    buffer: buffer,
    extension: 'png',
  });
  //Tamaños de columnas
  this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
  this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
  // Exportación del excel
  this.printExcel(nombreArchivo, libroExcel);
  }
  /* Metodos de exportación a excel */
  /* Operativo */
  public async generateEventos(titulo: string, encabezado: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if( number >= 0 && number <= 5 || number >= 7 && number <= 11 || number >= 15 && number <= 20 || number >= 22 && number <= 24){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else if(number === 6 || number === 21){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.numFmt = 'dd/mmm/yyyy';
        }else if(number >= 12 && number <= 14 || number === 19){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
          cell.numFmt = '#,##0';
        }
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo, 60);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelOperativoAnalisis(tituloHoja: string, titulos: string[], encabezado: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      if(number == 2 || number == 4 || number == 6){
        hojaTrabajo.mergeCells(Number(cell.row), Number(cell.col),Number(cell.row), Number(cell.col)+1);
      }
      if(number < 2){
        color = '00FFFFFF'
      }

      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    headers2.eachCell((cell, number) => {
      let alineacion = 'center';
      if(number == 1){
        alineacion = 'left'
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number == 2 ){
          cell.numFmt = '#,##0'
        }
        if(number == 3){
          cell.numFmt = '0.0%'
        }
        if(number == 4 || number == 6){
          cell.numFmt = '#,##0.0'
        }
        let alineacion = 'center';
        if(number == 1){
          alineacion = 'left';
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00e0e0e0';
        let estilo = 'thin';
        if(number == 5 || number == 7){
          if(cell.value == 'Tolerable'){
            fondo = '004CAF50';
          }else if(cell.value == 'Moderado'){
            fondo = '00ffeb3b';
          }else if(cell.value == 'Relevante'){
            fondo = '00FF8300';
          }else if(cell.value == 'Inaceptable'){
            fondo = '00f44336';
          }else if(cell.value == 'Muy bajo'){
            fondo = '004CAF50';
          }else if(cell.value == 'Bajo'){
            fondo = '007ce980';
          }else if(cell.value == 'Medio'){
            fondo = '00ffeb3b';
          }else if(cell.value == 'Alto'){
            fondo = '00FF8300';
          }else if(cell.value == 'Muy alto'){
            fondo = '00f44336';
          }else{
            fondo = '00e0e0e0';
          }          
          cell.border = {
            left: { style: 'thin', color: { argb: '00e0e0e0' },},
            right: { style: 'thick', color: { argb: fondo },},
            top: { style: 'thin', color: { argb: '00e0e0e0' },},
            bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
          };
        }else{
          fondo = '00e0e0e0';
          cell.border = {
            left: { style: 'thin', color: { argb: '00e0e0e0' },},
            right: { style: 'thin', color: { argb: fondo },},
            top: { style: 'thin', color: { argb: '00e0e0e0' },},
            bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
          };
        }
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00FFFFFF' },
          bgColor: { argb: '00000000' },
        };
        

      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelOpAnalisisComb(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string, perdida, metrica){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    //Se genera el formato de los datos
    var c = 0;
    for (const d of datos) {
      c++;
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if((perdida == "pxPerdida" && number > 4) || (perdida == "pxPérdida patrimonial" && number == 4)
            || (perdida == "pyPerdida" && c > 3) || (perdida == "pyPérdida patrimonial" && c == 3) || metrica == "prop" ){
          cell.numFmt = '0.0%';
        }else{
          cell.numFmt = '#,##0'
        }
        let alineacion = 'center';
        if(number == 1){
          alineacion = 'left';
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = 'FF000000';
        let fondo = '00FFFFFF';
        if((number == titulos.length || c == datos.length) && perdida == ""){
          fondo = '00C4C4C4';
          isBold = true;
          color = '00616161';
        }
        if((perdida == "pxPerdida" || perdida == "pxPérdida patrimonial") && c == datos.length){
          fondo = '00C4C4C4';
          isBold = true;
          color = '00616161';
        }
        if((perdida == "pyPerdida" || perdida == "pyPérdida patrimonial") && number == titulos.length){
          fondo = '00C4C4C4';
          isBold = true;
          color = '00616161';
        }
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: color },
        };
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };

      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelOperativoMapaTab(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        let alineacion = 'center';

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';
      
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };

      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelOperativoMapaCalor(tituloHoja: string, titulos: string[], encabezado: string[], datos: any, nombreArchivo: string, colores: any, tab: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezado);

    headers.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number == 2 && tab == 1){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+3)
      }
      if(number == 2 && tab == 2){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+4)
      }

      if(number > 2){
        color = '00cbcdcf';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    headers2.eachCell((cell, number) => {
      let alineacion = "center";
      let color = '00E0E0E0'
      if(number == 1){
        color = "00cbcdcf"
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });
    
    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        let alineacion = 'center';

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = colores[i][number-1];
      
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };

      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  /* Operativo Potencial*/
  public async generateEventosPot(titulo: string, encabezado: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if( number >= 1 && number <= 10 || number >= 14 && number <= 21){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else if( number === 0 || number >= 22){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.numFmt = 'dd/mmm/yyyy';
        }else if(number >= 11 && number <= 13 ){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
          cell.numFmt = '#,##0';
        }
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo, 60);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }

  // -----------MODULO TENDENCIA DE CREDITO----------------------------
  async generatoExcelMatrizTransicionMonto(tituloHoja,encabezado,dataarreglo,nombreArch, metrica){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(encabezado);
    
    headers.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number > 1){
        color = '00cbcdcf';
      }else{
        color = '00FFFFFF';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    var j = 2;
    for(const i of dataarreglo){
      let row = hojaTrabajo.addRow(i);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(metrica === 'general')
          cell.numFmt = '#,##0.0#';
        else
          cell.numFmt = '0.#0%';

        let alineacion = "center";
        if(number == 1){
          alineacion = 'center';
        } else{
          alineacion = 'right';
        }

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        var colorTxt = '00616161';
        if(number == 1){
          color = '00cbcdcf';
          isBold = true;
          colorTxt = '00616161';
        }
        const isGeneral = metrica === 'general' || metrica === 'total';
        const inRange = !isGeneral || number < encabezado.length;

        if (j === number && inRange) {
          color = '00f1f1f1'; // naranja
        } else if (number > j && inRange) {
          color = '00FBCDBA'; // gris diagonal
        } else if (number < j &&number !== 1 &&(!isGeneral || j !== encabezado.length)) {
          color = '00C8E3BB'; // verde
        }     
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: colorTxt },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      j++;
    }

    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArch, libroExcel);
  }
  async generatoExcelMatrizTransicionCredito(tituloHoja,encabezado,dataarreglo,nombreArch, metrica){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(encabezado);
    
    headers.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number > 1){
        color = '00cbcdcf';
      }else{
        color = '00FFFFFF';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    for(const d of dataarreglo){
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number > 1){
          if(metrica === 'general')
            cell.numFmt = '#,##0.0#';
          else
            cell.numFmt = '0.#0%';        
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: 'center',
        };
        var isBold = false;
        var color = '00FFFFFF';
        var font = 'FF000000';
        if(number == 1){
          color = '00cbcdcf';
          isBold = true;
          font = '00616161';
        }
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: font },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      })
    }

    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    this.printExcel(nombreArch, libroExcel);
    
  }
  async generateExcelCosecha(tituloHoja,encabezado,data,numeroevaluaciones,names,porPorcent,nombreArch) {  
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(encabezado);
    // var data = [];
    //  data = dataarreglo;
    var pos = numeroevaluaciones+2;
    // Cell Style : Fill and Border
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'E0E0E0' },
        bgColor: { argb: 'E0E0E0' },
        
      }
      cell.alignment = {
        vertical: 'middle', horizontal: 'center'
      }
    })
    for(const d of data){
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell,number) => {
        var isBold = false;
        var color = '00FFFFFF';
        var txtColor = 'FF000000'
        if(number == 2){
          cell.numFmt = '#,##0'
          color = '00f1f1f1'
        }
        if(number > 2){
          if(porPorcent && names == 'Porcentaje por mora'){
            cell.numFmt = '0.#0%'
            isBold = true;
            if(Number(cell.value) > 0.10){
              txtColor = '00FF495C'
            }
          }else{
            cell.numFmt = '#,##0'
          }
          
        }
        if(number == pos){
          color = 'E7E6E6';
        }
        if(number > pos){
          color = 'f1f1f1';
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          // horizontal: alineacion,
        };
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: txtColor },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
       
      });
      pos--;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    this.printExcel(nombreArch, libroExcel);
  }
  async generateExcelConcentracion(tituloHoja,encabezado,dataarreglo,nombreArch) {    
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(encabezado);

    var data = [];
    data = dataarreglo;
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'E0E0E0' },
        bgColor: { argb: 'E0E0E0' }
      }
      cell.alignment = {
        vertical: 'middle', horizontal: 'center'
      }
    })
    var j = 0;
    data.forEach(d => {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 }
      row.eachCell((cell, number) => {
        if(number > 2 && (j%2 == 0)){
          cell.numFmt = '#,##0';        
        }
        if(number > 2 && (j%2 != 0)){
          cell.numFmt = '##0.00'
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: 'center',
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      })
      j++;
    });
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    this.printExcel(nombreArch, libroExcel);
  }
  async generateExcelMayDeud(tituloHoja,encabezado,dataarreglo,numeroevaluaciones,nombreArch) {    
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(encabezado);

    var data = [];
    data = dataarreglo;

    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    })
    data.forEach(d => {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 }
      row.eachCell((cell, number) => {
        if(number == 2){
          cell.numFmt = '#,##0'
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: 'center',
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      })
    })
     // Introducción de la imagen
     const imageSrc = 'assets/img/creado.png';
     const response = await fetch(imageSrc);
     const buffer = await response.arrayBuffer();
     let imageId1 = libroExcel.addImage({
       buffer: buffer,
       extension: 'png',
     });
     //Tamaños de columnas
     this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
     this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
     this.printExcel(nombreArch, libroExcel);
  }
  /* --------------- Modulo Financiero --------------- */
  /* Catalogo de cuentas y estados financieros */
  public async generateEstadosFinancieros(titulo: string, encabezado: string[], datos: any, nombreArchivo: string, niveles: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    var i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if(number === 1  || number === 2){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          }
          cell.numFmt = '#,##0';
        }
        // Relleno de las celdas
        if(niveles[i] !== 1){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: false,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
          if(number === 2){
            let espacios = '';
            for(var esp = 1; esp < niveles[i]; esp++){
              espacios += '   ';
            }
            cell.value = espacios+cell.value
          }
        }else{
          var color = '00EDEDED';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: false,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
        }
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async generateEstadosFinancierosV(titulo: string, encabezado: string[], datos: any, nombreArchivo: string, niveles: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      if(number%2===0 && number >2){
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: true,
          color: { argb: 'FF004A98' },
        };
      }else{
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: true,
          color: { argb: 'FFFFFFFF' },
        };
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    var i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if(number === 1  || number === 2){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          }
          if(number%2===0){
            cell.numFmt  = '0.0#%';
          }else{
            cell.numFmt = '#,##0';
          }
        }
        // Relleno de las celdas
        if(niveles[i] !== 1){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          if(number%2===0 && number >2){
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: true,
              color: { argb: 'FF4280E0' },
            };
          }else{
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: false,
              color: { argb: 'FF000000' },
            };
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
          if(number === 2){
            let espacios = '';
            for(var esp = 1; esp < niveles[i]; esp++){
              espacios += '   ';
            }
            cell.value = espacios+cell.value
          }
        }else{
          var color = '00EDEDED';
          // Formato y estilo del texto
          if(number%2===0 && number >2){
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: true,
              color: { argb: 'FF004A98' },
            };
          }else{
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: false,
              color: { argb: 'FF000000' },
            };
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
        }
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async generateEstadosFinancierosH(titulo: string, encabezado: string[], datos: any, nombreArchivo: string, niveles: any, titulos: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers2 = hojaTrabajo.addRow('');
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    let posicion = undefined;
    headers.eachCell((cell, number) => {
      if(cell.value === 'Variación' && posicion === undefined){
        posicion = number;
      }
      if(number >= posicion && posicion !== undefined){
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: true,
          color: { argb: 'FF004A98' },
        };
      }else{
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: true,
          color: { argb: 'FFFFFFFF' },
        };
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };

    });

    hojaTrabajo.getRow(headers2.number).values = titulos;
    headers2.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number >= posicion && (number-posicion)%2===0){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+1);
      }
      if(number >= posicion){
        color = '00C4C4C4';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FF004A98' },
      };
      
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    var i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if(number === 1  || number === 2){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          }
          if(number < posicion || (number >= posicion && (number-posicion)%2===0)){
            cell.numFmt = '#,##0';
          }else{
            cell.numFmt = '0.#%';
          }
        }
        // Relleno de las celdas
        if(niveles[i] !== 1){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          if(number >= posicion){
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: true,
              color: { argb: 'FF4280E0' },
            };
          }else{
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: false,
              color: { argb: 'FF000000' },
            };
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
          if(number === 2){
            let espacios = '';
            for(var esp = 1; esp < niveles[i]; esp++){
              espacios += '   ';
            }
            cell.value = espacios+cell.value
          }
        }else{
          var color = '00EDEDED';
          // Formato y estilo del texto
          if(number >= posicion){
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: true,
              color: { argb: 'FF004A98' },
            };
          }else{
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: false,
              color: { argb: 'FF000000' },
            };
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
        }
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  //metodo exportar excel Razones Financieras 
  public async generateRazonesFinancieras(titulo: string, encabezado: string[], datos: any, nombreArchivo: string, niveles: any, colores: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d), pos = 0;
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.

        if(number > 5){
          if(d[number-1] !== ''){
            cell.numFmt = '#,##0.0#';
            let col = colores[i][pos];
            cell.border = {
              left: { style: 'thick', color: { argb: this.semaforo(col) }, },
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
            pos++;
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        }else if(number > 1){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.border = {
            left: { style: 'thin', color: { argb: '00e0e0e0' },},
            right: { style: 'thin', color: { argb: '00e0e0e0' },},
            top: { style: 'thin', color: { argb: '00e0e0e0' },},
            bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
          };
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
          cell.border = {
            left: { style: 'thin', color: { argb: '00e0e0e0' },},
            right: { style: 'thin', color: { argb: '00e0e0e0' },},
            top: { style: 'thin', color: { argb: '00e0e0e0' },},
            bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
          };
        }
        
        // Relleno de las celdas
        if(niveles[i] !== 1){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: false,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
          if(number === 1){
            let espacios = '';
            espacios += '   ';
            cell.value = espacios+cell.value
          }
        }else{
          var color = '00EDEDED';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
          cell.border = {
            left: { style: 'thin', color: { argb: '00e0e0e0' },},
            right: { style: 'thin', color: { argb: '00e0e0e0' },},
            top: { style: 'thin', color: { argb: '00e0e0e0' },},
            bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
          };
        }
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  private semaforo(col: string) {
    switch (col) {
      case 'R':
        return '00FF495C';
      case 'A-':
        return '00FF8300';
      case 'A+':
      case 'A':
        return '00FFD100';
      case 'V':
        return '0072D54A';
      default:
        return '00b3b3b3';
    }
  }
private semaforosGestion(semaforos: any, porcentaje: any) {
    if(porcentaje === null){
      return '00b3b3b3';
    }
    var valfin = 0;
    for(const sem of semaforos){
      if(valfin < sem.valfin){
        valfin = sem.valfin
      }
    }
    if(porcentaje >= valfin){
      porcentaje = valfin-1;
    }
    var col = '';
    for (const sem of semaforos) {
      var ab = sem.valIn;
      if(ab !== 0){
        ab = ab-0.1;
      }
      if(porcentaje >= ab && porcentaje <= sem.valfin){
        col = sem.color;
        break;
      }
    }
    switch (col) {
      case 'rojo':
        return '00FF495C';
      case 'naranja':
        return '00FF8300';
      case 'amarillo':
        return '00FFD100';
      case 'azul':
        return '000075C9';
      case 'verde':
        return '0072D54A';
      default:
        return '00b3b3b3';
    }
    return '00b3b3b3';
  }

  //exportar excel Financiero-Indicadores productividad-Cartera regular
  public async excelFinancieroIndProd(titulo: string, encabezado: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(d[number-1] < 10000){
          cell.numFmt = '#,##0.0#'; //este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        }else{
          cell.numFmt = '#,##0'; //este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        }
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        let alineacion = "left";
        if(number > 2){
          alineacion = "right";
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  //metodo expotar a excel tabla de financiero-Indicadores de cobertura 
  public async excelFinancieroIndCobertura(tituloHoja: string, titulos: any, encabezados: any, datos: any, nombreArchivo: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);

    headers.eachCell((cell, number) => {
      let color = '00cbcdcf';
      let alineacion = 'left';
      if(number == 1 || number == 2 ){
        alineacion = 'left';
      } else{
        alineacion = 'center';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    headers2.eachCell((cell, number) => {
      let alineacion = "left";
      if(number == 1 || number == 2 ){
        alineacion = 'left';
      } else{
        alineacion = 'center';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    for(const i of datos){
      let row = hojaTrabajo.addRow(i);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number > 3){
          cell.numFmt = '#,##0';
          if(number == 8  || number == 11){
            cell.numFmt = '0%'
          }
        }

        let alineacion = "left";
        if(number == 1 || number == 2 ){
          alineacion = 'left';
        } else{
          alineacion = 'center';
        }

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }

    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  } 

  //metodo exportar excel tabla cobertura riesgos
  public async excelFinancieroCoberRiesgo(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string, nivel: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      
      let alineacion = 'center';
      if(number == 1){
        alineacion = 'left';
      } 
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });
    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number == 2 || number == 4){
          cell.numFmt = '#,##0';
        }
        if(number == 3){
          cell.numFmt = '0.0%'
        }
        
        let alineacion = 'left';
        if(number == 2 || number == 4){
          alineacion = 'right';
        } 
        if(number == 3 || (i > 8 && number == 1)){
          alineacion = 'center'
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        if(nivel[i] == 1){
          var color = '00EDEDED';
            // Formato y estilo del texto
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: false,
              color: { argb: 'FF000000' },
            };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: color },
              bgColor: { argb: 'FFEDEDED' },
            };
        } else if(nivel[i] == 2){
          var color = 'f9f9f9';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: false,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
        } else{
          var color = 'ffffff';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: false,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
        }
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }

// -----------MODULO GESTION ESTRATEGICA ----------------------------
// FORMULACION
  //Generacion de excel para el tablero de Gestion estrategica- Formulacion- Indicadores-metas
  public async generateExcelIndicadoresFormulacion(titulo: string, aniosSeleccionados: any, subtitulos: any, headers: any, contenido: any, nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');

    let ubicTitulos = [];
    let ubicHeaders = [];
    const ubicAniosSel = hojaTrabajo.addRow(['Años seleccionados: ', ... aniosSeleccionados]);
    for(let i = 0; i < subtitulos.length; i++){
      ubicTitulos.push(hojaTrabajo.addRow([]));
      ubicHeaders.push(hojaTrabajo.addRow([...headers[i]]));
      for(const d of contenido[i]){
        hojaTrabajo.addRow(d);
      }
      hojaTrabajo.addRow([]);
    }
  
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    for(let i = 0; i < ubicTitulos.length; i++){
      ubicTitulos[i].values = [subtitulos[i]];
      ubicTitulos[i].getCell(1).font = {
        color: {argb: '0A4E97' }
      }
      const rownumber = ubicTitulos[i].number
      hojaTrabajo.mergeCells(rownumber, 1, rownumber, 2);
    }

    for(const ubiHeader of ubicHeaders){
      ubiHeader.eachCell((cell) => {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
          };
    
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00C4C4C4' },
            bgColor: { argb: '00000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        
      });
    }
    this.printExcel(nombre, libroExcel);

  }  
  public async generateExcelPerspectivas(titulo: string, encabezado: string[], data: any, nombre: string) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let header = hojaTrabajo.addRow(encabezado);

    header.eachCell((cell) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    for(const d of data) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };

      row.getCell(1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }
      row.getCell(1).font = {
        color: {argb: '0A4E97' }
      }
      row.getCell(2).alignment = {
        wrapText:true
      }
    }
      
      let dataMax: number[];
      let max: number;
      hojaTrabajo.columns.forEach((column: any, index) => {
        dataMax = [];
        column.eachCell({ includeEmpty: false }, (cell: any) => {
          dataMax.push(cell.value?.toString().length || 0);
        });
        max = Math.max(...dataMax);
        if(index == 1){
          column.width = max < 10 ? 10 : max /  2;
        }else{
          column.width = max < 10 ? 10 : max;
        }
      });
  
      const imageSrc = 'assets/img/creado.png';
      const response = await fetch(imageSrc);
      const buffer = await response.arrayBuffer();
  
      let imageId1 = libroExcel.addImage({
        buffer: buffer,
        extension: 'png',
      });
      
      this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);

    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelProyectosEstrategicosFormulacion(titulo: string, headers: any, proyectos: any, actividades: any, filtros: any, nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    const ubicTableHeaders = hojaTrabajo.addRow([...headers[0]]);
    let row;
    for(let i = 0; i< proyectos.length; i++){
      row = hojaTrabajo.addRow([...proyectos[i]]);
      row.eachCell((cell, index) => {
        if(index === 1 || index === 2){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else if(index === 4 || index ===6){
          cell.numFmt = 'dd-mmm-yyyy';
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00E6E7E8' },
          bgColor: { argb: '00E6E7E8' },
        };
      })
      for(const act of actividades[i]){
        let rowAct = hojaTrabajo.addRow([...act])
        rowAct.eachCell((cell, index) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: '00000000' },
          };
          if(index === 1 || index === 2){
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            };
          }else if(index === 4 || index ===6){
            cell.numFmt = 'dd-mmm-yyyy';
          }else{
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
          }
        })
      }
    }

    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    
    ubicTableHeaders.eachCell((cell) => {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
          };
    
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00C4C4C4' },
            bgColor: { argb: '00000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        
      });


    this.printExcel(nombre, libroExcel);

  }
  public async generateExcelFilosofiaCorp(titulo: string, encabezado: string[], data: any, nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let header = hojaTrabajo.addRow(encabezado);

    header.eachCell((cell) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    for(const d of data) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };

      row.getCell(1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }
      row.getCell(1).font = {
        color: {argb: '0A4E97' }
      }
      row.getCell(2).alignment = {
        wrapText:true
      }
    }
    
    let dataMax: number[];
      let max: number;
      hojaTrabajo.columns.forEach((column: any, index) => {
        dataMax = [];
        column.eachCell({ includeEmpty: false }, (cell: any) => {
          dataMax.push(cell.value?.toString().length || 0);
        });
        max = Math.max(...dataMax);
        column.width = max < 10 ? 10 : max;
      });
  
      const imageSrc = 'assets/img/creado.png';
      const response = await fetch(imageSrc);
      const buffer = await response.arrayBuffer();
  
      let imageId1 = libroExcel.addImage({
        buffer: buffer,
        extension: 'png',
      });
      
      this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    this.printExcel(nombre, libroExcel);
  }
   public async generateExcelMatrizFoda(titulo: string, header1: any, header2: any, data1: any, data2: any, nombre: string, tituloTabla1: string, tituloTabla2: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let ubiTitle1 = hojaTrabajo.addRow([]);
    let headerT1 = hojaTrabajo.addRow(header1);

    headerT1.eachCell((cell) => {
      if(cell.value &&  cell.value?.toString().length > 0 ){
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: true,
          color: { argb: 'FFFFFFFF' },
        };
  
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00C4C4C4' },
          bgColor: { argb: '00000000' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center',
        };
      }
    });

    let r = 8;
    for(const d of data1[0]){
      let row = hojaTrabajo.getRow(r)
      for(let i = 1; i  <= d.length;   i++){
        row.getCell(i).value = d[i-1];
      }
      r++;
    }

    r = 8;
    for(const d of data1[1]){
      let row = hojaTrabajo.getRow(r)
      for(let i = 0; i  <= d.length;   i++){
        row.getCell(i+4).value = d[i];
      }
      r++;
    }    

    hojaTrabajo.addRow([]);
    let ubiTitle2 = hojaTrabajo.addRow([]);
    let headerT2 = hojaTrabajo.addRow(header2);

    headerT2.eachCell((cell) => {
      if(cell.value &&  cell.value?.toString().length > 0 ){
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: true,
          color: { argb: 'FFFFFFFF' },
        };
  
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00C4C4C4' },
          bgColor: { argb: '00000000' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center',
        };
      }
      
    });

    let lastRowOrig = hojaTrabajo.lastRow?.number;
    let lastRow = hojaTrabajo.lastRow?.number;
    if(lastRow){
      lastRow++;
      for(const d of data2[0]){
        let row = hojaTrabajo.getRow(lastRow)
        for(let i = 1; i  <= d.length;   i++){
          row.getCell(i).value = d[i-1];
        }
        lastRow++;
      }
      lastRow = lastRowOrig! + 1;
      for(const d of data2[1]){
        let row = hojaTrabajo.getRow(lastRow!)
        for(let i = 0; i  <= d.length;   i++){
          row.getCell(i+4).value = d[i];
        }
        lastRow!++;
      } 
    }
  
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    ubiTitle2.values = [tituloTabla2];
    ubiTitle1.values = [tituloTabla1];
    hojaTrabajo.mergeCells(ubiTitle1.number, 1, ubiTitle1.number, 2);
    hojaTrabajo.mergeCells(ubiTitle2.number, 1, ubiTitle2.number, 2);

    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelCMIFormulacion(tit: string,encab: string[],datos: any,nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: false,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00FFFFFF' },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelObjetivosFormulacion(titulo: string, subtitulos: any, headers: any, contenido: any, nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');

    let ubicTitulos = [];
    let ubicHeaders = [];
    for (let i = 0; i < subtitulos.length; i++) {
      ubicTitulos.push(hojaTrabajo.addRow([]));
      ubicHeaders.push(hojaTrabajo.addRow([...headers[i]]));
      for(const d of contenido[i]){
        hojaTrabajo.addRow(d);
      }
      hojaTrabajo.addRow([]);
    }
  
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);

    for(let i = 0; i < ubicTitulos.length; i++){
      ubicTitulos[i].values = [subtitulos[i]];
      ubicTitulos[i].getCell(1).font = {
        color: {argb: '0A4E97' }
      }
      const rownumber = ubicTitulos[i].number
      hojaTrabajo.mergeCells(rownumber, 1, rownumber, 2);
    }

    for(const ubiHeader of ubicHeaders){
      ubiHeader.eachCell((cell) => {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
          };
    
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00C4C4C4' },
            bgColor: { argb: '00000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        
      });
    }
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelActasFormulacion(titulo: string, headers: any, proyectos: any, actividades: any, filtros: any, nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    const ubicTableHeaders = hojaTrabajo.addRow([...headers[0]]);
    let row;
    for(let i = 0; i< proyectos.length; i++){
      row = hojaTrabajo.addRow([...proyectos[i]]);
      row.eachCell((cell, index) => {
        if(index === 1 || index === 2){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }else if(index === 3 || index ===5){
          cell.numFmt = 'dd-mmm-yyyy';
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00E6E7E8' },
          bgColor: { argb: '00E6E7E8' },
        };
      })
      for(const act of actividades[i]){
        let rowAct = hojaTrabajo.addRow([...act])
        rowAct.eachCell((cell, index) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: '00000000' },
          };
          if(index === 1 || index === 2){
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            };
          }else if(index === 3 || index ===5){
            cell.numFmt = 'dd-mmm-yyyy';
          }else{
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
          }
        })
      }
    }
  
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);

      ubicTableHeaders.eachCell((cell) => {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
          };
    
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00C4C4C4' },
            bgColor: { argb: '00000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        
      });


    this.printExcel(nombre, libroExcel);

  }
    public async generateExcelAlineamientoEstrategicoFormulacion(titulo: string, titulosTablas: any, headerTablas: any, contenidoTabla: any, nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');

    let ubicTitulos = [];
    let ubicHeaders = [];

    for(let i = 0; i< titulosTablas.length; i++){
      ubicTitulos.push(hojaTrabajo.addRow([]));
      ubicHeaders.push(hojaTrabajo.addRow([...headerTablas[i]]))
      if(contenidoTabla[i].length >0 ){
        for(const c of contenidoTabla[i]){
          let row = hojaTrabajo.addRow(c)
          row.eachCell((cell, indx) => {
            if(indx == 1 ){
              cell.alignment = {
                vertical: 'middle',
                horizontal: 'center',
              }
            }
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: '00FFFFFF' },
              bgColor: { argb: '00000000' },
            };
          })
        }
      }else{
        hojaTrabajo.addRow(['','','']).eachCell(cell => {cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00FFFFFF' },
          bgColor: { argb: '00000000' },
        };})
      }
      hojaTrabajo.addRow([])
    }
    
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);

    for(let i = 0; i < ubicTitulos.length; i++){
      ubicTitulos[i].values = [titulosTablas[i]];
      ubicTitulos[i].getCell(1).font = {
        color: {argb: '0A4E97' }
      }
      const rownumber = ubicTitulos[i].number
      hojaTrabajo.mergeCells(rownumber, 1, rownumber, 2);
    }

    for(const ubiHeader of ubicHeaders){
      ubiHeader.eachCell((cell) => {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
          };
    
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00C4C4C4' },
            bgColor: { argb: '00000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        
      });
    }
    this.printExcel(nombre, libroExcel);

  }
  // SEGUIMIENTO
  public async generateExcelProyectos(tit: string,encab: string[],datos: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number === 9) {
          cell.numFmt = '#,##0.0#';
          cell.border = {
            left: {
              style: 'thick',
              color: {
                argb: this.semaforosGestion(semaforos,(d[number - 1] * 100) / d[number - 2]),
              },
            },
          };
          if(d[number - 1] === 'null'){
            cell.value = 0;
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 4 || number === 6) {
          cell.numFmt = 'dd/mmm/yyyy';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number === 5) {
          cell.numFmt = '#,##0';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number === 8) {
          cell.numFmt = '#,##0.0#';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number >= 10) {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 3){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
        var isBold = false;
        var color = '00FFFFFF';
        if(d[2].split('-').length === 1){
          isBold = true;
          color = 'EEEEEEEE';
        }else{
          if(number === 3){
            cell.value = '  '+d[2].split('-')[1];
          }
        }
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelProyectosAvance(tit: string,encab: string[],datos: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number === 6) {
          cell.numFmt = '#,##0.0#';
          cell.border = {
            left: {
              style: 'thick',
              color: {
                argb: this.semaforosGestion(semaforos,(d[number - 1] * 100) / d[number - 2]),
              },
            },
          };
          if(d[number - 1] === 'null'){
            cell.value = 0;
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 5) {
          cell.numFmt = '#,##0.0#';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 4 || number === 3) {
          cell.numFmt = 'dd/mmm/yyyy';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
        var isBold = false;
        var color = '00FFFFFF';
        if(d[0].split('-').length === 1){
          isBold = true;
          color = 'EEEEEEEE';
        }else{
          if(number === 1){
            cell.value = '  '+d[0].split('-')[1];
          }
        }
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelCMISeguimiento(tit: string,encab: string[],datos: any,nombre: string,semaforos: any){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number === 3 && d[number - 1] !== ''){
          cell.numFmt = '0.0#%';
          cell.border = {
            left: {
              style: 'thick',
              color: { argb: this.semaforo(semaforos) },
            },
          };
        }else if(number === 3 && d[number - 1] === ''){
          cell.numFmt = '0.0#%';
          cell.border = {
            left: {
              style: 'thick',
              color: { argb: this.semaforo(semaforos) },
            },
          };
        }
        var isBold = false;
        var color = '00FFFFFF';
        if(d[1].split('-').length === 1){
          isBold = true;
          color = 'EEEEEEEE';
        }else{
          if(number === 2){
            cell.value = '  '+d[1].split('-')[1];
          }
        }
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00FFFFFF' },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
   /* MODULO GESTION ESTRATEGICA - SEGIMIENTO - OBJETIVOS */
  private titulos(hojaTrabajo: ExcelJS.Worksheet, encab: string[]){
    let header = hojaTrabajo.addRow(encab);

    header.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      if(number <= 3 || number > 6){
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left',
        };
      }else if(number >= 4 && number <=6){
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      }
    });
  }

  public async generateExcelObjetivos2(tit: string,encab: string[],data: any,nombre: string,semaforos: any, avancePlan: number) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');

    hojaTrabajo.addRow([]);
    let row = hojaTrabajo.addRow(['Avance del plan:','','','','',avancePlan])
    var ad = '';
    row.eachCell((cell, number) => {
      ad = cell.address[cell.address.length-1];
      if(number === 6){
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 14,
          bold: true,
          color: { argb: '00000000' },
        };
        cell.numFmt = '0.00%';
        cell.border = {
          left: {
            style: 'thick',
            color: { argb: this.semaforo(semaforos) },
          },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '004490B8' },//this.semaforo(semaforos, avancePlan * 100)
          bgColor: { argb: '00FFFFFF' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      }else{
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 14,
          bold: true,
          color: { argb: 'FFFFFFFF' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '004490B8' },
          bgColor: { argb: '00000000' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      }
    });
    let merg = 'A'+ad+':E'+ad;
    hojaTrabajo.mergeCells(merg);
    
    const datos = data;
    // Formateo de los datos
    for (const d of datos) {
      if(d[0] === ''){
        hojaTrabajo.addRow([]);
      }
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(d[2] === ''){
          if(d[1] === ''){
            if(number === 6){
              this.titulos(hojaTrabajo, encab);
              cell.font = {
                name: 'Arial Narrow',
                family: 4,
                bold: true,
                size: 12,
                color: { argb: '00000000' },
              };
              cell.numFmt = '0.00%';
              cell.border = {
                left: {
                  style: 'thick',
                  color: { argb: this.semaforo(semaforos) },
                },
              };
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'EEEEEEEE' },//this.semaforo(semaforos, d[number - 1] * 100)
                bgColor: { argb: '00FFFFFF' },
              };
              cell.alignment = {
                vertical: 'middle',
                horizontal: 'right',
              };
            }else{
              cell.font = {
                name: 'Arial Narrow',
                family: 4,
                size: 12,
                bold: true,
                color: { argb: '00A6A6A6' },
              };
        
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'EEEEEEEE' },
                bgColor: { argb: '00FFFFFF' },
              };
              cell.alignment = {
                vertical: 'middle',
                horizontal: 'center',
              };
            }
          }else{
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 12,
              bold: true,
              color: { argb: 'FFFFFFFF' },
            };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: '004EA5D3' },
              bgColor: { argb: '00000000' },
            };
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
            if(number === 6){
              cell.font = {
                name: 'Arial Narrow',
                family: 4,
                bold: true,
                size: 12,
                color: { argb: '00000000' },
              };
              cell.numFmt = '0.00%';
              cell.border = {
                left: {
                  style: 'thick',
                  color: { argb: this.semaforo(semaforos) },
                },
              };
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '004EA5D3' },//this.semaforo(semaforos, d[number - 1] * 100)
                bgColor: { argb: '00FFFFFF' },
              };
              cell.alignment = {
                vertical: 'middle',
                horizontal: 'right',
              };
            }
          }
        }else{
          if(number === 6){
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              bold: true,
              color: { argb: '00000000' },
            };
            cell.numFmt = '0.00%';
            cell.border = {
              left: {
                style: 'thick',
                color: { argb: this.semaforo(semaforos) },
              },
            };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: '00FFFFFF' },//this.semaforo(semaforos, d[number - 1] * 100)
              bgColor: { argb: '00FFFFFF' },
            };
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'right',
            };
          }else if (number === 2 || number === 4 || number === 5) {
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              color: { argb: 'FF000000' },
            };
            if(number === 2){
              cell.numFmt = '#,##0';
              cell.alignment = {
                vertical: 'middle',
                horizontal: 'center',
              };
            }else{
              cell.numFmt = '#,##0.00';
              cell.alignment = {
                vertical: 'middle',
                horizontal: 'right',
              };
            }
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: '00FFFFFF' },
              bgColor: { argb: 'FF000000' },
            };
          }else{
            cell.font = {
              name: 'Arial Narrow',
              family: 4,
              size: 11,
              color: { argb: 'FF000000' },
            };
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: '00FFFFFF' },
              bgColor: { argb: 'FF000000' },
            };
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            };
          }
        }
      });
    }
  
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });

    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);

    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelPlanes(tit: string,encab: string[],datos: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number === 7) {
          cell.numFmt = '#,##0.0#';
          cell.border = {
            left: {
              style: 'thick',
              color: {
                argb: this.semaforosGestion(semaforos,(d[number - 1] * 100) / d[number - 2]),
              },
            },
          };
          if(d[number - 1] === 'null'){
            cell.value = 0;
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 2 || number === 3) {
          cell.numFmt = 'dd/mmm/yyyy';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number === 5) {
          cell.numFmt = '#,##0.0#';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number === 6) {
          cell.numFmt = '#,##0.0#';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 8) {
          cell.numFmt = '0.0#%';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number >= 9) {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number ===   1){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
        var isBold = false;
        var color = '00FFFFFF';
        if(d[0].split('-').length === 1){
          isBold = true;
          color = 'EEEEEEEE';
        }else{
          if(number === 1){
            cell.value = '  '+d[0].split('-')[1];
          }
        }
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelIndicadores(tit: string,encab: string[],encab2: string[],data: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado1 = encab2;
    let NuevaLinea1 = hojaTrabajo.addRow(encabezado1);
    // Cell Style : Fill and Border
    var cel1 = ''; 
    NuevaLinea1.eachCell((cell, number) => {
      if(cell.value !== ''){
        cel1 = cell.address;
      }else if(cel1 !== '' && cell.value === ''){
        hojaTrabajo.mergeCells(cel1+':'+cell.address);
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of data) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number % 2 !== 0 && number > 5) {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: '00000000' },
          };
          if (d[number - 1][0] !== '') {
            cell.numFmt = '#,##0.0#';
            if(d[number - 1][0] === null){
              d[number - 1] = 0;
            }
            d[number - 1] = Number(d[number - 1]);            
            let porcentaje = 0; 
            if( cell.value[0] === 'null' ){
              porcentaje = cell.value[1];
              cell.value = 0;
            }else{
              porcentaje = cell.value[1];
              cell.value = Number(cell.value[0]);
            }
            cell.border = {
              left: {
                style: 'thick',
                color: {
                  argb: this.semaforo(semaforos),
                },
              },
            };
          }else{
            cell.value = cell.value[0]
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: '00FFFFFF' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number >= 6) {
          if (d[number - 1] != '') {
            cell.numFmt = '#,##0.0#';
            cell.value = Number(cell.value);
            d[number - 1] = Number(d[number - 1]);
          }
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00E0E0E0' },
            bgColor: { argb: '00FFFFFF' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: 'FF000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelActas(tit: string,encab: string[],datos: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number === 6) {
          cell.numFmt = '#,##0.0#';
          cell.border = {
            left: {
              style: 'thick',
              color: {
                argb: this.semaforo(
                  semaforos
                ),
              },
            },
          };
          if(d[number - 1] === 'null'){
            cell.value = 0;
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 2 || number === 3) {
          cell.numFmt = 'dd/mmm/yyyy';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number === 5) {
          cell.numFmt = '#,##0.0#';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 7) {
          if(d[number - 1] === 'null'){
            cell.value =  'Sin validar';
          }else if(d[number - 1] === 'false'){
            cell.value = 'Sin validar';
          }else if(d[number - 1] === 'true'){
            cell.value = 'Validado';
          }else if(d[number - 1] === ''){
            cell.value = '';
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        } else if (number >= 8) {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number ===   1){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
        var isBold = false;
        var color = '00FFFFFF';
        if(d[0].split('-').length === 1){
          isBold = true;
          color = 'EEEEEEEE';
        }else{
          if(number === 1){
            cell.value = '  '+d[0].split('-')[1];
          }
        }
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelProgramas(tit: string,encab: string[],data: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Formateo de los datos
    for (const d of data) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number === 5) {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: '00000000' },
          };
          cell.numFmt = '#,##0.0#';
          cell.border = {
            left: {
              style: 'thick',
              color: {
                argb: this.semaforo(
                  semaforos
                ),
              },
            },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: '00FFFFFF' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 4) {
          cell.numFmt = '#,##0.0#';
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: 'FF000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else if (number === 6) {
          cell.numFmt = '#,##0';
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: 'FF000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else {
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00FFFFFF' },
            bgColor: { argb: 'FF000000' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelProgramasPorg(tit: string,encab: string[],data: any,nombre: string,semaforos: any) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Encabezados
    const encabezado = encab;
    let NuevaLinea = hojaTrabajo.addRow(encabezado);
    // Cell Style : Fill and Border
    NuevaLinea.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    var merge = [];
    // Formateo de los datos
    for (const d of data) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if (number === 7) {
          cell.numFmt = '#,##0.0#';
          cell.border = {
            left: {
              style: 'thick',
              color: {
                argb: this.semaforo(
                  semaforos
                ),
              },
            },
          };
          if(d[number-1] === 'null'){
            cell.value = 0;
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 6) {
          cell.numFmt = '#,##0.0#';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'right',
          };
        } else if (number === 2 || number === 4) {
          cell.numFmt = 'dd/mmm/yyyy';
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
        var isBold = false;
        if(d[0].split('*').length > 1){
          if(number === 1){
            cell.value = d[0].split('*')[1];
            merge = [cell.row, cell.col];
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
          }
        }
        if(d[0].split('-').length === 1){
          isBold = true;
          color = 'EEEEEEEE';
        }else{
          if(number === 1){
            cell.value = '  '+d[0].split('-')[1];
          }
        }
        var color = '00FFFFFF';
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    hojaTrabajo.mergeCells(merge[0],merge[1],merge[0],merge[1]+6)
    // Exportación del excel
    this.printExcel(nombre, libroExcel);
  }
      /*MODULO RESULTADOS*/
    /* Exportación seguimiento de planes */
  public async generateTableSeguimientoPlanes(titulo: string, encabezado: string[], datos: any, nombreArchivo: string, alineaciones?: string[], colores?: string[][]){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    for (const [i, d] of datos.entries()) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.alignment = {
          vertical: 'middle',
          horizontal: (alineaciones?.[number - 1] ?? 'left') as 'left' | 'center' | 'right',
        };
        // Barra de color a la derecha de la celda (semáforo), si la fila trae color para esa columna
        const colorBarra = colores?.[i]?.[number - 1];
        if(colorBarra){
          cell.border = { right: { style: 'thick', color: { argb: '00' + colorBarra.split('#')[1] } } };
        }
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        if(!d[0].includes('-')){
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00dbdbdf' }
          }; 
        }else if(number === 1){
          cell.value = `   ${d[0].split('-')[1]}`
        }
        if(number === 3 || number === 5){
          cell.style.alignment.vertical = 'middle';
          cell.numFmt = 'dd/mmm/yyyy';
        }else if( number === 4){
          cell.style.alignment.vertical = 'middle';
          cell.numFmt = '#,##0.0#';
        }else if( number === 6){
          cell.style.alignment.vertical = 'middle';
          cell.numFmt = '#,##0.0#';
        }
      });
    }
    // Introducción de la imagen
    const imageSrc = './../../../assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }

  /** Administrador */
  public async generateExcelResponsables(tit: string,encab: string[],data: any,nombre: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');

    const datos = data;
    this.titulos(hojaTrabajo, encab);
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 12,
          color: { argb: '00000000' },
        };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFFFF' },
          bgColor: { argb: '00000000' },
        };
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left',
        };
      });
    }

    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });

    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    this.addTituloFechaPlataforma(hojaTrabajo, tit, imageId1);
    this.printExcel(nombre, libroExcel);
  }
  public async generateExcelPlanificaciones(
    titulo: string,
    encab: string[],
    data: any,
    nombre: string
  ) {
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');

    let encabezado = hojaTrabajo.addRow(encab);

    encabezado.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    for (const d of data) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      let cell = row.getCell(6);

      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    }
    let dataMax: number[];
    let max: number;
    hojaTrabajo.columns.forEach((column: any) => {
      dataMax = [];
      column.eachCell({ includeEmpty: false }, (cell: any) => {
        dataMax.push(cell.value?.toString().length || 0);
      });
      max = Math.max(...dataMax);
      column.width = max < 10 ? 10 : max;
    });
  
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();

    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    this.printExcel(nombre, libroExcel);
  }

  /*MODULO COMERCIAL */
  /*Exportar por sucursales */
public async generateSucursalesAll(
  titulo: string,
  encab: any,
  data: any,
  nombre: string,
  formatos: any,
  alineacion: any,
) {
  let libroExcel = this.createExcel();
  let hojaTrabajo = libroExcel.getWorksheet('Tabla');

  encab.forEach((en, i) => {
    let encabezado = hojaTrabajo.addRow(en);

    encabezado.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    for (const d of data[i]) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        cell.numFmt = formatos[i][number - 1];
        cell.alignment = {
          vertical: 'middle',
          horizontal: alineacion[i][number - 1] as 'left' | 'center' | 'right',
        };
        var isBold = false;
        var color = '00FFFFFF';
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
      });
    }
    let dataMax: number[];
    let max: number;
    hojaTrabajo.columns.forEach((column: any) => {
      dataMax = [];
      column.eachCell({ includeEmpty: false }, (cell: any) => {
        const textLength = cell.text?.toString().length || cell.value?.toString().length || 0;
        dataMax.push(textLength);
      });
      max = Math.max(...dataMax);
      column.width = max < 15 ? 15 : max;
    });

    hojaTrabajo.addRow([]);
  });
  const imageSrc = 'assets/img/creado.png';
  const response = await fetch(imageSrc);
  const buffer = await response.arrayBuffer();

  let imageId1 = libroExcel.addImage({
    buffer: buffer,
    extension: 'png',
  });

  this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
  this.printExcel(nombre, libroExcel);
}

/*MODULO DE RIESGO DE LIQUIDEZ*/
  //metodo exportar excel tabla liquidez-concentracion 
  public async excelLiquidezConcentracion(tituloHoja: string, titulos: string[], encabezados: string[], datos: any, totales: any, nombreArchivo: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);

    headers.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number == 3){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+1)
      }
      if(number == 5){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+2)
      }
      if(number > 2){
        color = '00cbcdcf';
      }  
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    headers2.eachCell((cell, number) => {
      let alineacion = "left";
      if(number == 1){
        alineacion = 'left';
      } else if(number == 4 || number == 7){
        alineacion = 'center';
      } else{
        alineacion = 'right';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    for(const d of datos){
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        let alineacion = "left";
          if(number > 1 && number <= 6){
            cell.numFmt = '#,##0';
            if(number == 4){
              cell.numFmt = '0.0%'
            }
            if(number == 5 || number == 6){
              cell.numFmt = '0%'
            }            
          }          
          if(number == 1){
            alineacion = 'left';
          } else if(number == 4 || number == 7){
            alineacion = 'center';
          } else{
            alineacion = 'right';
          }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      })
    }
    
    let row = hojaTrabajo.addRow(totales);
    row.font = { name: 'Arial Narrow', family: 4, size: 11 };
    row.eachCell((cell, number) => {
      if(number > 1 && number <= 6){
        cell.numFmt = '#,##0.0#';
        if(number == 4){
          cell.numFmt = '0%'
        }
      }

      let alineacion = "left";
      if(number == 1){
        alineacion = 'left';
      } else if(number == 4 || number == 7){
        alineacion = 'center';
      } else{
        alineacion = 'right';
      }

      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
      
      var color = '00FFFFFF';
      // Formato y estilo del texto
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FF000000' },
      };
      // Relleno de las celdas
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: 'FF000000' },
      };

    })
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
    public async excelLiquidezMayores(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number == 3 || number == 4){
          cell.numFmt = '#,##0'
        }
        let alineacion = 'center';

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';

        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
    public async excelLiquidezCarteraMay(tituloHoja: string, titulos: string[], encabezados: string[], datos: any, nombreArchivo: string, rango){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      if(number == 1 || number == 2){
        color = '00FFFFFF';
      }
      if(number == 3){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+2)
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    headers2.eachCell((cell, number) => {
      let alineacion = "left";
      if(number > 1){
        alineacion = 'right';
      } 
      if(number > 3){
        alineacion = 'center'
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        let alineacion = 'left';
        if(number == 2 || number == 3){
          cell.numFmt = '#,##0'
          alineacion = 'right'
        }
        if(number == 4 || number == 5){
          cell.numFmt = '0.0%'
          alineacion = 'center'
        }


        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';
        if(rango[i] == "w3-light-green2" && number == 6){
          fondo = '00C8E3BB'
        }
        if(rango[i] == "w3-orange2" && number == 6){
          fondo = '00FBCDBA'
        }
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };

      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelCreditoPropVar(tituloHoja: string, titulos: string[], encabezados: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      if(number == 1){
        color = '00FFFFFF';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    headers2.eachCell((cell, number) => {
      let alineacion = "center";
      if(number > 1){
        cell.numFmt = '#,##0'
      } 
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number > 1){
          cell.numFmt = '0.0%'
        }
        let alineacion = 'center';
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelLiquidezLimites(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    //Se genera el formato de los datos
    let i = 1;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        
        if(number == 2 || number == 3){
          cell.numFmt = '#,##0';
        }
        if(number == 4){
          cell.numFmt = '0.0%';
        }


        let alineacion = 'center';
        // if(number == 1){
        //   alineacion = 'left'
        // }
        // if((number == 1 || number == 2) && i > 4){
        //   alineacion = 'left'
        // }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
    //metodo expotar a excel tabla de credito-estimaciones
  public async excelCreditoEstimaciones(tituloHoja: string, titulos: string[], encabezados: string[], datos: any, totales: any, nombreArchivo: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);

    headers.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number == 4){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+1)
      }
      if(number == 6){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+3)
      }
      if(number > 3){
        color = '00cbcdcf';
      }else{
        color = '00FFFFFF';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    headers2.eachCell((cell, number) => {
      let alineacion = "left";
      if(number == 1){
        alineacion = 'left';
      } else if(number == 2 || number == 3 || number == 8 || number == 11){
        alineacion = 'center';
      } else{
        alineacion = 'right';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    for(const i of datos){
      let row = hojaTrabajo.addRow(i);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number > 3){
          cell.numFmt = '#,##0';
          if(number == 6  || number == 9){
            cell.numFmt = '0.0%'
          }
        }

        let alineacion = "left";
        if(number == 1){
          alineacion = 'left';
        } else if(number == 2 || number == 3 || number == 8 || number == 11){
          alineacion = 'center';
        } else{
          alineacion = 'right';
        }

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
    }

    let row = hojaTrabajo.addRow(totales);
    row.font = { name: 'Arial Narrow', family: 4, size: 11 };
    row.eachCell((cell, number) => {
      if(number > 3){
        cell.numFmt = '#,##0';
        if(number == 8  || number == 11){
          cell.numFmt = '0.0%'
        }
      }

      let alineacion = "left";
      if(number == 1){
        alineacion = 'left';
      } else if(number == 2 || number == 3 || number == 8 || number == 11){
        alineacion = 'center';
      } else{
        alineacion = 'right';
      }

      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
      var isBold = true;
      var color = '00FFFFFF';
      // Formato y estilo del texto
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: isBold,
        color: { argb: 'FF000000' },
      };
      // Relleno de las celdas
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: 'FF000000' },
      };
    });

    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }

  /*MODULO RIESGO DE CREDITO_A  */
  //metodo exportar excel tabla credito-concentracion 
  public async excelCreditoConcentracion(tituloHoja: string, titulos: string[], encabezados: string[], datos: any, totales: any, nombreArchivo: string){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);

    headers.eachCell((cell, number) => {
      let color = '00FFFFFF';
      if(number == 3){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+3)
      }
      if(number == 7){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+2)
      }
      if(number > 2){
        color = '00cbcdcf';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    headers2.eachCell((cell, number) => {
      let alineacion = "left";
      if(number == 1){
        alineacion = 'left';
      } else if(number >= 4 && number <= 8 && number !== 5){
        alineacion = 'center';
      } else{
        alineacion = 'right';
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    for(const d of datos){
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(number > 1 && number <= 8){
          cell.numFmt = '#,##0';
          if(number == 4 || number == 6){
            cell.numFmt = '0.0%'
          }
          if(number == 7 || number == 8){
            cell.numFmt = '0%'
          }
          
        }

        let alineacion = "left";
        if(number == 1){
          alineacion = 'left';
        } else if(number >= 4 && number <= 8 && number !== 5){
          alineacion = 'center';
        } else{
          alineacion = 'right';
        }

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: color },
          bgColor: { argb: 'FF000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      })
    }
    
    let row = hojaTrabajo.addRow(totales);
    row.font = { name: 'Arial Narrow', family: 4, size: 11 };
    row.eachCell((cell, number) => {
      if(number > 1 && number <= 8){
        cell.numFmt = '#,##0.0#';
        if(number == 4 || number == 6){
          cell.numFmt = '0%'
        }
      }

      let alineacion = "left";
      if(number == 1){
        alineacion = 'left';
      } else if(number >= 4 && number <= 8 && number !== 5){
        alineacion = 'center';
      } else{
        alineacion = 'right';
      }

      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
      
      var color = '00FFFFFF';
      // Formato y estilo del texto
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FF000000' },
      };
      // Relleno de las celdas
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color },
        bgColor: { argb: 'FF000000' },
      };

    })
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelCreditoCarteraMay(tituloHoja: string, titulos: string[], encabezados: string[], datos: any, nombreArchivo: string, rango){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    let headers2 = hojaTrabajo.addRow(encabezados);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      if(number == 1 || number == 2){
        color = '00FFFFFF';
      }
      if(number == 3){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+4)
      }
      if(number == 8){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+1)
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    headers2.eachCell((cell, number) => {
      let alineacion = "left";
      if(number > 1){
        alineacion = 'right'
      }
      if(number > 5){
        alineacion = 'center';
      } 
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });

    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        let alineacion = 'left';
        if(number >= 2 && number <= 5){
          cell.numFmt = '#,##0'
          alineacion = 'right'
        }
        if(number == 6 || number == 8){
          cell.numFmt = '0.0%'
          alineacion = 'center'
        }
        if(number == 7){
          cell.numFmt = '0.00%'
          alineacion = 'center'
        }

        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';
        if(rango[i] == "w3-light-green2" && number == 9){
          fondo = '00C8E3BB'
        }
        if(rango[i] == "w3-orange2" && number == 9){
          fondo = '00FBCDBA'
        }
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  public async excelCreditoLimites(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    //formato de los headers
    headers.eachCell((cell, number) => {
      let color = '00C4C4C4';
      
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb:  color },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });

    //Se genera el formato de los datos
    let i = 1;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        if(i == 1 && number == 2){
          hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+1)
        }
        if((i == 5 || i == 6) && number == 1){
          hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+1)
        }
        
        if(number > 1 && (i == 1 || i == 3 || i == 5)){
          cell.numFmt = '#,##0';
        }
        if(number > 1){
          cell.numFmt = '#,##0';
        }
        if(i == 2 && number > 1){
          cell.numFmt = '0.0%';
        }


        let alineacion = 'center';
        if(number == 1){
          alineacion = 'left'
        }
        if((number == 1 || number == 2) && i > 4){
          alineacion = 'left'
        }
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = false;
        var color = '00FFFFFF';
        
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00FFFFFF';
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: fondo },
          bgColor: { argb: '00000000' },
        };
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: '00e0e0e0' },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
      });
      i++
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }

  // -----------MODULO SEGUIMIENTO PRESUPUESTAL - ESTADOS FINANCIEROS -----------
  public async generateEstadosFinancierosConAnalisis(
    titulo: string,
    encabezado1: string[],
    encabezado: string[],
    cuentas: any[],
    nombreArchivo: string,
    analisisVertical: boolean = false,
    semaforo: boolean = false,
    semaforosVariacion: any[] = [],
    semaforos: any[] = [],
    metrica: number
  ){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    
    // Agregar encabezados
    let headers = hojaTrabajo.addRow(encabezado1);
    
    // Formato de headers
    headers.eachCell((cell, number) => {
      let tam = (encabezado1.length - 3) / 2;
      if(number == 3){
        if(metrica == 1)
          hojaTrabajo.mergeCells( Number(cell.row), Number(cell.col), Number(cell.row), Number(cell.col)+encabezado1.length-3 );
        else{
          hojaTrabajo.mergeCells( Number(cell.row), Number(cell.col), Number(cell.row), Number(cell.col)+tam );
        }          
      }
      if(number == 7 && !analisisVertical && metrica == 2){
        hojaTrabajo.mergeCells( Number(cell.row), Number(cell.col), Number(cell.row), Number(cell.col)+tam );
        cell.border = {left: { style: 'thin' }};
      }
      if(number == 9 && analisisVertical && metrica == 2){
        hojaTrabajo.mergeCells( Number(cell.row), Number(cell.col), Number(cell.row), Number(cell.col)+tam );
        cell.border = {left: { style: 'thin' }};
      }
      let color = 'FFFFFFF';
      if(number > 2 ) color = '00C4C4C4';
      cell.font = { name: 'Arial Narrow', family: 4, size: 11, bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:  color} };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    });
    // Agregar encabezados
    let headers1 = hojaTrabajo.addRow(encabezado);
    
    // Formato de headers
    headers1.eachCell((cell, number) => {      
      cell.font = { name: 'Arial Narrow', family: 4, size: 11, bold: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    
    // Procesar datos recursivamente
    for(let cuenta of cuentas ){
      const rowData: any[] = [];
      const indentacion = '   '.repeat(cuenta.nivel - 1); // Indentación visual
      
      // Columna 1: Código
      rowData.push(cuenta.codigo);
      
      // Columna 2: Nombre con indentación
      rowData.push(indentacion + cuenta.nombre);
      
      // Columna 3: Presupuesto
      rowData.push(this.formatearValor(cuenta.presupuesto));
      
      // Columna 4: Presupuesto % (análisis vertical)
      if (analisisVertical) {
        rowData.push(cuenta.presupuesto !== '-' ? cuenta.analisisVerticalPresupuesto + '%' : '-');
      }
      
      // Columna 5: Real
      rowData.push(this.formatearValor(cuenta.real));
      
      // Columna 6: Real % (análisis vertical)
      if (analisisVertical) {
        rowData.push(cuenta.real !== '-' ? cuenta.analisisVerticalReal + '%' : '-');
      }
      
      // Columna 7: Variación
      rowData.push(this.formatearValor(cuenta.variacion));
      
      // Columna 8: Cumplimiento
      rowData.push(this.formatearValor(cuenta.cumplimiento) + '%');
      //Metrica de movimientos del mes
      if(metrica === 2){
        // Columna 9: Presupuesto
        rowData.push(this.formatearValor(cuenta.presupuesto));
        
        // Columna 10: Presupuesto % (análisis vertical)
        if (analisisVertical) {
          rowData.push(cuenta.presupuesto !== '-' ? cuenta.analisisVerticalPresupuesto + '%' : '-');
        }
        
        // Columna 11: Real
        rowData.push(this.formatearValor(cuenta.real));
        
        // Columna 12: Real % (análisis vertical)
        if (analisisVertical) {
          rowData.push(cuenta.real !== '-' ? cuenta.analisisVerticalReal + '%' : '-');
        }
        
        // Columna 13: Variación
        rowData.push(this.formatearValor(cuenta.variacion));
        
        // Columna 14: Cumplimiento
        rowData.push(this.formatearValor(cuenta.cumplimiento) + '%');
      }
      
      const row = hojaTrabajo.addRow(rowData);
      
      // Aplicar estilos
      row.eachCell((cell, index) => {
        cell.font = { 
          name: 'Arial Narrow', 
          family: 4, 
          size: 10,
          bold: cuenta.nivel === 1 // Negrita para nivel 1
        };
        
        cell.alignment = { 
          horizontal: index <= 2 ? 'left' : 'right', 
          vertical: 'middle'
        };
        
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
          left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
          bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
          right: { style: 'thin', color: { argb: 'FFE0E0E0' } }
        };
        
        // Aplicar colores de semáforo si está activado
        if (semaforo) {
          let color = null;
          
          // Variación con semáforo
          if (index === 7 && cuenta.variacion !== '-') {
            const numValor = Number(cuenta.variacion);
            const semaf = semaforosVariacion.find(s => numValor >= s.min && numValor <= s.max);
            if (semaf) {
              color = semaf.color;
            }
          }
          
          // Cumplimiento con semáforo
          if (index === 8 && cuenta.cumplimiento !== '-') {
            const numValor = Number(cuenta.cumplimiento);
            const semaf = semaforos.find(s => numValor >= s.min && numValor <= s.max);
            if (semaf) {
              color = semaf.color;
            }
          }
          
          if (color) {
            cell.font = { 
              ...cell.font, 
              color: { argb: this.hexToArgb(color) } 
            };
          }
        }
      });
    }
    
    // Ajustar ancho de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    
    // Agregar imagen y encabezados
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    
    // Exportar
    this.printExcel(nombreArchivo, libroExcel);
  }
  /**
   * Metodo para exportar el catalogo de cuentas de seguimiento presupuestal
   * @param titulo titulo del excel
   * @param encabezado encabezados de la tabla
   * @param cuentas data de cuentas visibles 
   * @param nombreArchivo 
   * @param real Bandera para indicar si se imprimen ejecutados o presupuestos 
   */
  public async generateCatalogoCuentas(
    titulo: string,
    encabezado: string[],
    cuentas: any[],
    nombreArchivo: string,
    real: boolean,
  ){
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    
    // Agregar encabezados
    let headers = hojaTrabajo.addRow(encabezado);
    
    // Formato de headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });    
    
    // Procesar datos recursivamente
    const procesarCuentas = (cuentasLista: any[], nivel: number = 0) => {
      for (const cuenta of cuentasLista) {        
        const rowData: any[] = [];
        const indentacion = '   '.repeat(nivel - 1); // Indentación visual
        
        // Columna 1: Código
        rowData.push(cuenta.codigo);
        
        // Columna 2: Nombre con indentación
        rowData.push(indentacion + cuenta.nombre);
        
        // Columnas meses
        for(let i = 0; i < cuenta.datos.length; i++){
          rowData.push(this.formatearValor(cuenta.datos[i].valor));
        }
        const row = hojaTrabajo.addRow(rowData);
        
        // Aplicar estilos
        row.eachCell((cell, index) => {
          cell.font = { 
            name: 'Arial Narrow', 
            family: 4, 
            size: 10,
            bold: cuenta.nivel === 1 // Negrita para nivel 1
          };
          
          cell.alignment = { 
            horizontal: index <= 2 ? 'left' : 'right', 
            vertical: 'middle'
          };
          
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
            left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
            bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
            right: { style: 'thin', color: { argb: 'FFE0E0E0' } }
          };
        });
        
        // Procesar hijos
        if (cuenta.hijos && cuenta.expandido && cuenta.hijos.length > 0) {
          procesarCuentas(cuenta.hijos, nivel + 1);
        }
      }
    };
    
    procesarCuentas(cuentas.filter(cuenta => cuenta.nivel === 1), 1);
    
    // Ajustar ancho de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);
    
    // Agregar imagen y encabezados
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    
    // Exportar
    this.printExcel(nombreArchivo, libroExcel);
  }
  
  // Método auxiliar para formatear valores
  private formatearValor(valor: number | string): string {
    if (valor === '-') return '-';
    if (typeof valor === 'string') return valor;
    return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  
  // Método auxiliar para convertir hex a ARGB
  private hexToArgb(hex: string): string {
    const cleanHex = hex.replace('#', '');
    return 'FF' + cleanHex.toUpperCase();
  }

  // MODULO RIESGO DE LIQUIDEZ 
  //metodo exportar a excel tabla de GAP
  public async generateGAP(titulo: string, encabezado: string[], encabezado2: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      if(number === 2){
        hojaTrabajo.mergeCells( Number(cell.row), Number(cell.col), Number(cell.row), Number(cell.col)+encabezado2.length-3 );
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Se hace la asignación de encabezados de la tabla
    let headers2 = hojaTrabajo.addRow(encabezado2);
    //formato de los headers
    headers2.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if(number>1){
          cell.numFmt = '#,##0.0#';
        }
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left',
        };
        let negro = true
        if(number!==1){
          if(d[number-1] === Number(d[number-1]) && d[number-1]<0){
            negro = false; 
          }else if(d[number-1] !== Number(d[number-1])){
            negro = false;
          }
        }
        let borde = false, col = 'FF000000';
        if(d[number-1] === 'VRL'){
          borde = true;
          negro = true;
          col = '00FF495C';
        }
        if(d[number-1] === 'Cubierto con AL'){
          borde = true;
          negro = true;
          col = '00FFD100';
        }
        if(d[number-1] === 'GAP positivo'){
          borde = true;
          negro = true;
          col = '0072D54A';
        }
        var isBold = false;
        if(d[0] !== 'Total' && !d[0].includes('-')){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: isBold,
            color: { argb: negro?'FF000000':'FFFF0000' },
          };
          if(borde){
            cell.border = {
              left: { style: 'thick', color: { argb: col },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }else if(d[number-1]!==''){
            cell.border = {
              left: { style: 'thin', color: { argb: '00e0e0e0' },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }
          // Relleno de las celdas
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
        }else{
           var color = '00EDEDED';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: negro?'FF000000':'FFFF0000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
          if(borde){
            cell.border = {
              left: { style: 'thick', color: { argb: col },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }else if(d[number-1]!==''){
            cell.border = {
              left: { style: 'thin', color: { argb: '00e0e0e0' },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }
          if(number===1 && d[0].includes('-')){
            cell.value = ''+d[0].split('-')[1];
          }
        }
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
    //metodo exportar excel tabla cobertura
  public async generateCobertura(titulo: string, encabezado: string[], encabezado2: string[], datos: any, nombreArchivo: string, merge: any, encabezados: any){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow('');
    let headers2 = hojaTrabajo.addRow('');
    //Se genera el formato de los datos
    let i = 0;
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      let pos = 0;
      row.eachCell((cell, number) => {
        //cell.numFmt = '#,##0.0#'; este es el formato que se pone en las celdas para que los números ya salgan separados por miles.
        //cell.numFmt = 'dd/mmm/yyyy'; este es el formato en el caso de requerir usar fechas.
        // Fomato de la celda alineación y otros.
        if(number > 1){
          if(d[number-1] === Number(d[number-1])){
            cell.numFmt = '#,##0.0#';
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'right',
            };
          }else{
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
          }
        }else{
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
        // Relleno de las celdas
        if(!encabezados[i] && !d[0].includes('Total')){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: false,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
          if(number === 1){
            let espacios = '';
            espacios += '   ';
            cell.value = espacios+cell.value
          }
        }else{
          var color = '00EDEDED';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
        }
        if(merge[i]){
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FF000000' },
          }
        }
        pos++;
      });
      i++;
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);

    for(var row = 8; row<datos.length+8; row++){
      if(merge[row-8]){
        const cell = hojaTrabajo.getRow(row)['_cells'][0];
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+3)
      }
    }

    hojaTrabajo.getRow(headers.number).values = encabezado;
    hojaTrabajo.getRow(headers2.number).values = encabezado2;
    //formato de los headers
    headers.eachCell((cell, number) => {
      if(number===1){
        hojaTrabajo.mergeCells(Number(cell.row),Number(cell.col),Number(cell.row),Number(cell.col)+3)
      }
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    headers2.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  //metodo exportar a excel tabla de ACTIVOS PONDERADOS
  public async generateActivosPonderados(titulo: string, encabezado: string[], datos: any, nombreArchivo: string){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(encabezado);
    //formato de los headers
    headers.eachCell((cell, number) => {
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFFFFFF' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00C4C4C4' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
      };
    });
    //Se genera el formato de los datos
    for (const d of datos) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        // Fomato de la celda alineación y otros.
        if(number>2){
          cell.numFmt = '#,##0.0#';
        }
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left',
        };
        let borde = false, col = 'FF000000';
        var isBold = false;
        if(d[0] !== 'Total' && !d[0].includes('-')){
          var color = '00FFFFFF';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: isBold,
            color: { argb: 'FF000000' },
          };
          if(borde){
            cell.border = {
              left: { style: 'thick', color: { argb: col },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }else if(d[number-1]!==''){
            cell.border = {
              left: { style: 'thin', color: { argb: '00e0e0e0' },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }
          // Relleno de las celdas
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FF000000' },
          };
        }else{
           var color = '00EDEDED';
          // Formato y estilo del texto
          cell.font = {
            name: 'Arial Narrow',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FF000000' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: color },
            bgColor: { argb: 'FFEDEDED' },
          };
          if(borde){
            cell.border = {
              left: { style: 'thick', color: { argb: col },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }else if(d[number-1]!==''){
            cell.border = {
              left: { style: 'thin', color: { argb: '00e0e0e0' },},
              right: { style: 'thin', color: { argb: '00e0e0e0' },},
              top: { style: 'thin', color: { argb: '00e0e0e0' },},
              bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
            };
          }
          if(number===1 && d[0].includes('-')){
            cell.value = ''+d[0].split('-')[1];
          }
        }
      });
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, titulo, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
  //EXPORTACION DE TABLAS CALCE DE PLAZOS -RIESGO DE LIQUIDEZ 
  public async excelCalcePlazos(tituloHoja: string, titulos: string[], datos: any, nombreArchivo: string, colspan: boolean[], codigos:number){
    // Se genera el libro de excel sobre el que se trabajara
    let libroExcel = this.createExcel();
    let hojaTrabajo = libroExcel.getWorksheet('Tabla');
    // Se hace la asignación de encabezados de la tabla
    let headers = hojaTrabajo.addRow(titulos);
    headers.eachCell((cell, number) => {
      let alineacion = 'center';
      cell.font = {
        name: 'Arial Narrow',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00616161' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '00E0E0E0' },
        bgColor: { argb: '00000000' },
      };
      cell.alignment = {
        vertical: 'middle',
        //@ts-ignore
        horizontal: alineacion,
      };
    });
    //Se genera el formato de los datos
    for (const [index, d] of datos.entries()) {
      let row = hojaTrabajo.addRow(d);
      row.font = { name: 'Arial Narrow', family: 4, size: 11 };
      row.eachCell((cell, number) => {
        let alineacion = 'right';
        if(number > codigos+1 ){
          cell.numFmt = '#,##0.0'
        }else{
          alineacion = 'left';                   
        }
        
        cell.alignment = {
          vertical: 'middle',
          //@ts-ignore
          horizontal: alineacion,
        };
        var isBold = colspan[index];
        var color = '00FFFFFF';
        // Formato y estilo del texto
        cell.font = {
          name: 'Arial Narrow',
          family: 4,
          size: 11,
          bold: isBold,
          color: { argb: 'FF000000' },
        };
        let fondo = '00e0e0e0';       
        fondo = '00e0e0e0';
        cell.border = {
          left: { style: 'thin', color: { argb: '00e0e0e0' },},
          right: { style: 'thin', color: { argb: fondo },},
          top: { style: 'thin', color: { argb: '00e0e0e0' },},
          bottom: { style: 'thin', color: { argb: '00e0e0e0' },},
        };
        
        
        // Relleno de las celdas
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '00FFFFFF' },
          bgColor: { argb: '00000000' },
        };
        

      });
      if(colspan[index]){
        hojaTrabajo.mergeCells(row.number,1,row.number,codigos+1);
      } 
    }
    // Introducción de la imagen
    const imageSrc = 'assets/img/creado.png';
    const response = await fetch(imageSrc);
    const buffer = await response.arrayBuffer();
    let imageId1 = libroExcel.addImage({
      buffer: buffer,
      extension: 'png',
    });
    //Tamaños de columnas
    this.asignarTamanoDinamicoColumnas(hojaTrabajo);      
    this.addTituloFechaPlataforma(hojaTrabajo, tituloHoja, imageId1);
    // Exportación del excel
    this.printExcel(nombreArchivo, libroExcel);
  }
}
